/* eslint-env browser */

/**
 * Источник правды для значений из списка ниже - https://www.figma.com/file/Io1glMwpGl6u1jU8fiqUll/%F0%9F%A7%AC--LitRes-Components-Library-(Site)?node-id=47%3A2.
 * В случае изменения значений - не забудьте синхронизировать их с ./_media-queries.scss
 */

export enum EPlatform {
  mobile = "mobile",
  tablet = "tablet",
  desktop = "desktop",
}

export const breakpoints = {
  [EPlatform.mobile]: [360, 375, 414],
  [EPlatform.tablet]: [700, 1024],
  [EPlatform.desktop]: [1280, 1366, 1536, 1600, 1920],
};

export function checkIfMobileViewport() {
  reviewIfWindowExists();

  return window.innerWidth < breakpoints[EPlatform.tablet][0];
}

export function checkIfTabletViewport() {
  reviewIfWindowExists();

  return (
    window.innerWidth >= breakpoints[EPlatform.tablet][0] &&
    window.innerWidth < breakpoints[EPlatform.desktop][0]
  );
}

export function checkIfDesktopViewport() {
  reviewIfWindowExists();

  return window.innerWidth >= breakpoints[EPlatform.desktop][0];
}

function reviewIfWindowExists() {
  if (typeof window === "undefined") {
    throw new Error("The function can be called on client side only");
  }
}
